import React from 'react';
import { RedoOutlined } from '@ant-design/icons';
import {
  checkAccess,
  UserPermissions,
} from '@xbcb/client-utils/dist/checkAccess';
import { AccountType, RecordType } from '@xbcb/shared-types';
import { Modal } from 'antd';
import { isHydraMasterCiPlReworkEnabled } from 'featureFlags';
import {
  handleReworkMasterCiPl,
  isHydraMasterCiPlReadyForRework,
} from 'libs/handleReworkMasterCiPl';
import type { AppRecordSubmitButton } from 'routes';
import type { AppRecordOnConfirmPayload } from 'routes/types';

const REWORK_BUTTON_TEXT = (
  <div data-cy="rework-master-cipl-button">
    <RedoOutlined /> Rework Master CI/PL
  </div>
);

export const reworkMasterCiPlButton = (): AppRecordSubmitButton => ({
  key: 'reworkMasterCiPl',
  text: () => REWORK_BUTTON_TEXT,
  show: ({ currentUser, existingRecord }) => {
    return (
      isHydraMasterCiPlReworkEnabled &&
      !currentUser.loading &&
      currentUser.accountType === AccountType.OPERATOR &&
      checkAccess(
        currentUser,
        RecordType.US_CONSUMPTION_ENTRY,
        UserPermissions.UPDATE,
      ) &&
      isHydraMasterCiPlReadyForRework(existingRecord)
    );
  },
  onConfirm: () =>
    new Promise<AppRecordOnConfirmPayload>((resolve) => {
      Modal.confirm({
        title: 'Rework Master CI/PL?',
        content:
          'Confirm that Ops has aligned with the seller. This will reject the current CI/PL and create a new CIB task.',
        okText: 'Rework',
        cancelText: 'Cancel',
        onOk: () => resolve({ canceled: false }),
        onCancel: () => resolve({ canceled: true }),
      });
    }),
  skipValidation: () => true,
  skipUpdateRecord: () => true,
  onSubmit: async ({ updatedRecord, currentUser, history }) => {
    await handleReworkMasterCiPl({
      workOrderId: updatedRecord.id,
      currentUserId: currentUser.id,
      navigate: history.push,
    });
  },
});
